// window.addEventListener("DOMContentLoaded", (event) => {
  var start_url = window.location.href;
  var click_for_loc_chng = [...document.querySelectorAll('.ib-prod-variant input')];
  var backorder_div = [...document.querySelectorAll('.ibat-backorder')][0];
  var addtocart_div = [...document.querySelectorAll('.add-to-cart-wrapper')][0];
  /*  ------ For First Load Backorder ----- */
  var urlString = window.location.search;
  var path_for_api_fetch = window.location.pathname;
  var selection_div_for_padd = [...document.querySelectorAll('.ibat-your-selection')][0];
  var without_last_slash_for_api = path_for_api_fetch.endsWith("/") ? path_for_api_fetch.slice(0, -1) : path_for_api_fetch;
  var apiUrl = `${without_last_slash_for_api}.js`;
      fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        // Replace with  Package Protection and warranty Product id
        if(!backorder_div &&  data.id != '7314112905304' &&  data.id != '7311853027416' &&  data.id != '4492776833112'){
          if(urlString.length == 0){
            if(data.variants[0].inventory_quantity <= 0){
              addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
              if(selection_div_for_padd.classList.contains('ibat-without-backorder')){
                selection_div_for_padd.classList.remove('ibat-without-backorder');               
              }
            } 
            else if(data.variants[0].inventory_quantity <= 4 && data.variants[0].inventory_quantity >= 1){
              addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
              if(selection_div_for_padd.classList.contains('ibat-without-backorder')){
                selection_div_for_padd.classList.remove('ibat-without-backorder');
              }
            }
          }
          else if(urlString.startsWith("?variant=")){
            var variant_url_id = new URLSearchParams(urlString).get("variant");
            data.variants.forEach(variant => {
              if(variant.id == variant_url_id){
                if(variant.inventory_quantity <= 0){
                  addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
                  if(selection_div_for_padd.classList.contains('ibat-without-backorder')){
                    selection_div_for_padd.classList.remove('ibat-without-backorder');
                    ib_backorder.innerText = 'backorder';
                  }
                }
                else if(variant.inventory_quantity <= 4 && variant.inventory_quantity >= 1){
                  addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
                  if(selection_div_for_padd.classList.contains('ibat-without-backorder')){
                    selection_div_for_padd.classList.remove('ibat-without-backorder');
                  }
                }
              }
            });
          }
        }
        
      })
      .catch(error => {
        console.error("Error fetching product details:", error);
      });
  /*  ------ End First Load Backorder ----- */
  click_for_loc_chng.forEach(input_click => {
    input_click.addEventListener("click", function(e){
      setTimeout(function(){
        var change_url = window.location.href;
        if(change_url != start_url){
          var urlString_changed = window.location.search;
          var path_for_api_fetch_var_change = window.location.pathname;
          var without_last_slash_for_api_var_change = path_for_api_fetch_var_change.endsWith("/") ? path_for_api_fetch_var_change.slice(0, -1) : path_for_api_fetch_var_change;
          var apiUrl_change = `${without_last_slash_for_api_var_change}.js`;
          fetch(apiUrl_change)
          .then(response => response.json())
          .then(data => {
              if(urlString_changed.startsWith("?variant=")){
                var variant_url_id = new URLSearchParams(urlString_changed).get("variant");
                data.variants.forEach(variant => {
                  // Replace with  Package Protection and warranty Product id
                  if(variant.id == variant_url_id && data.id != '7314112905304' &&  data.id != '7311853027416' &&  data.id != '4492776833112'){
                    var backorder_div_variant_change = [...document.querySelectorAll('.ibat-backorder')][0];
                    var selection_div_for_padd_change = [...document.querySelectorAll('.ibat-your-selection')][0];
                    if(variant.inventory_quantity <= 0){
                      if(!backorder_div_variant_change){
                        addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
                        if(selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
                          selection_div_for_padd_change.classList.remove('ibat-without-backorder');
                        }
                      }
                      else if(backorder_div_variant_change.innerText.toLowerCase() != "backorder: ships once in stock"){
                        backorder_div_variant_change.remove();
                        addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
                        if(selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
                          selection_div_for_padd_change.classList.remove('ibat-without-backorder');
                        }
                      }
                    } 
                    else if(variant.inventory_quantity <= 4 && variant.inventory_quantity >= 1){
                      if(!backorder_div_variant_change){
                        addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
                        if(selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
                          selection_div_for_padd_change.classList.remove('ibat-without-backorder');
                        }
                      }
                      else if(backorder_div_variant_change.innerText.toLowerCase() != "less than 4 in stock"){
                        backorder_div_variant_change.remove();
                        addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
                        if(selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
                          selection_div_for_padd_change.classList.remove('ibat-without-backorder');
                        }
                      }
                    }
                    else {
                      if(backorder_div_variant_change){
                        backorder_div_variant_change.remove();
                        if(!selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
                          selection_div_for_padd_change.classList.add('ibat-without-backorder');
                        }
                      }
                    }
                  }
                });
              }
            
          })
          .catch(error => {
            console.error("Error fetching product details:", error);
          });
          start_url = change_url;
        }
      }, 800);
    });
  });
// });